import { createSlice } from "@reduxjs/toolkit";

const appControlSlice = createSlice({
  name: "appControl",
  initialState: {
    isLoading: false,
    alert: {
      start: false,
      message: null,
      type: null,
    },
  },
  reducers: {
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    showAlert: (state, action) => {
      state.alert = {
        start: true,
        ...action.payload,
      };
    },
    hideAlert: (state, action) => {
      state.alert = {
        start: false,
        message: null,
        type: null,
      };
    },
  },
});

export const { setIsLoading, showAlert, hideAlert } = appControlSlice.actions;

export const AppControlReducer = appControlSlice.reducer;
